import { TextColumn } from "@portal/BaseComponents/Table/Components/Text/TextColumn";

import { AppPageParams } from "@portal/lib/router/constants/page-info";
import { usePageNavigate } from "@portal/lib/router/hooks/usePageNavigae";
import { PTPList } from "@portal/types/entities/ptp";
import { CellRenderProps } from "@sinecycle/growcomponents";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

function PtpIDCell(props: CellRenderProps<PTPList>) {
  const { data } = props;
  const navigate = usePageNavigate();
  const { customer_id } = useParams<AppPageParams>();

  function handleQueryParams() {
    navigate({
      appPage: "PTP_DETAILS",
      pathParams: {
        customer_id: customer_id as string,
        ptp_id: data?.id as string,
      },
    });
  }
  function getId() {
    const copy = data?.id;
    return `PTP-${copy?.substring(0, 6).toLowerCase()}`;
  }
  const id = useMemo(getId, [data?.id]);

  return (
    <TextColumn
      text={id}
      type="Text"
      textProps={{
        ellipsis: { tooltip: data?.id },
        style: {
          maxWidth: "90px",
          color: "var(--primary-7)",
          cursor: "pointer",
        },
        onClick: handleQueryParams,
      }}
    />
  );
}

export { PtpIDCell };
